var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { InlineNameCell } from '@features/Attachments/components/InlineNameCell';
import { useAttachmentFieldCommit } from '../hooks/useAttachmentFieldCommit';
/**
 * Binds the shared inline `Name` cell (E2E-27) to Building's single-field PATCH. The
 * contentEditable revert rules live in `InlineNameCell` — every attachment surface needs exactly
 * the same ones, and they are subtle enough that a copy would drift.
 */
export function AttachmentNameCell({ item, buildingId }) {
    const { commit } = useAttachmentFieldCommit(buildingId, item.id);
    const commitName = (nextName) => __awaiter(this, void 0, void 0, function* () {
        const result = yield commit({ name: nextName });
        return result.success ? { success: true, name: result.row.name } : { success: false, error: result.error };
    });
    return React.createElement(InlineNameCell, { name: item.name, commitName: commitName });
}
